import React from 'react';

const RiskImpact = ({color}:{color?:string}) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.802036 7.59105L1.55638 6.74243C1.76471 6.50806 2.10238 6.50806 2.31071 6.74243L2.68772 7.16655L3.65105 6.08281C3.46339 5.28369 3.63906 4.39908 4.19606 3.77246L5.7044 2.0756C7.78708 -0.267386 11.1641 -0.267386 13.2471 2.0756L10.2301 3.77246V4.47558C10.2301 5.11195 10.0054 5.72244 9.60509 6.17244L7.96708 8.01517C7.41008 8.64179 6.62374 8.83942 5.9134 8.62829L4.95006 9.71203L5.32706 10.1362C5.5354 10.3705 5.5354 10.7504 5.32706 10.9848L4.57273 11.8334C4.36439 12.0678 4.02672 12.0678 3.81839 11.8334L0.801369 8.43929C0.593702 8.2053 0.593702 7.82542 0.802036 7.59105ZM10.3594 7.02106C10.4828 6.88231 10.5874 6.72893 10.6878 6.57293L19.1911 15.5042C20.0435 16.3997 20.0665 17.9113 19.2421 18.8391C18.4178 19.7668 17.0738 19.741 16.2778 18.7817L8.34008 9.21666C8.47208 9.10754 8.60342 8.99654 8.72142 8.86379L10.3594 7.02106Z"
        fill={color ?? "#36B37E"}
      />
    </svg>
  );
};

export default RiskImpact;
